// extracted by mini-css-extract-plugin
export default {"item":"StagesIconItem_item__AxFMw","number":"StagesIconItem_number__ThLgV","dates":"StagesIconItem_dates__RcSPt"};